import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormBuilder } from '@angular/forms';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { EspeciesGruposFormasService } from './especiesgruposformas.service';
import { HttpParams } from '@angular/common/http';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { Table } from 'primeng/table';
import { Tc, WBotanicaExtendedItemResultsViewModel, WBotanicaExtendedViewModel, EnumSiNoTodos } from 'src/app/components/core/_infrastructure/types/common';
import { FilterSearchingWBotanicaExtendedViewModel } from './especiesgruposformas.types';

@Component({
    selector: 'app-especiesgruposformas-list',
    templateUrl: './especiesgruposformas-list.component.html',
})
export class EspeciesGruposFormasListComponent extends ComponentBase implements OnInit {
    @ViewChild('tableSearch') turboTable: Table;

    listSiNoTodos: SelectItem[];
    IdCodigoEppo: number | null = null;
    resultEspeciesGruposFormas: WBotanicaExtendedItemResultsViewModel;
    cols: any[];

    listGrupo: Tc[];
    listForma: Tc[];
    listSubForma: Tc[];

    visibilitySpinner = false;

    public isCollapsed = false;

    constructor(
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        protected notificacionService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private confirmationService: ConfirmationService,
        private especiesGruposFormasService: EspeciesGruposFormasService,
    ) {
        super(authService, notificacionService, exceptionHandler);

        this.resultEspeciesGruposFormas = new WBotanicaExtendedItemResultsViewModel();
    }

    ngOnInit() {
        this.globalService.getGrupos().subscribe(res => {
            this.listGrupo = res;
        });

        this.cols = [
            { field: 'Link', header: '' },
            { field: 'Id', header: 'Id', display: 'none' },
            { field: 'IdNombreCientificoDescripcion', header: 'Nombre Cientí­fico' },
            { field: 'CodigoEppo', header: 'Código Eppo' },
            { field: 'Activo', header: 'Activa' },
            { field: 'NombreComun', header: 'Nombre Común' },
            { field: 'IdGrupoDescripcion', header: 'Grupo' },
            { field: 'IdFormaDescripcion', header: 'Forma' },
            { field: 'IdSubFormaDescripcion', header: 'Subforma' },
            { field: 'HabilitadoImportacion', header: 'Habilitada Importación' },
            { field: 'HabilitadoExportacion', header: 'Habilitada Exportación' },
            { field: 'HabilitadoChina', header: 'Habilitada China' },
            { field: 'EphytoReinoUnido', header: 'Ephyto Reino Unido' },
            { field: 'AplicaDocumentacion', header: 'Aplica Documentación' },
        ];

        this.form = this.fb.group({
            IdGrupo: null,
            IdForma: null,
            IdSubForma: null,
            CodigoEppo: '',
            IdNombreCientificoDescripcion: '',
            NombreComun: '',
            Activo: EnumSiNoTodos.TODOS,
            HabilitadoImportacion: EnumSiNoTodos.TODOS,
            HabilitadoExportacion: EnumSiNoTodos.TODOS,
            HabilitadoChina: EnumSiNoTodos.TODOS,
            EphytoReinoUnido: EnumSiNoTodos.TODOS,
            AplicaDocumentacion: EnumSiNoTodos.TODOS,
        });

        this.isCollapsed = false;

        //p-selectButton
        this.listSiNoTodos = [
            { label: 'Sí', value: EnumSiNoTodos.SI },
            { label: 'NO', value: EnumSiNoTodos.NO },
            { label: 'TODOS', value: EnumSiNoTodos.TODOS },
        ];

        this.loadBack();
    }

    loadBack() {
        let hayFiltros = false;

        if (this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.IdGrupo != null) {
            this.form.patchValue({
                IdGrupo: this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.IdGrupo,
            });

            this.onSelectGrupo();

            this.form.patchValue({
                IdForma: this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.IdForma,
            });

            this.onSelectForma();

            this.form.patchValue({
                IdSubForma: this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.IdSubForma,
            });

            hayFiltros = true;
        }

        if (
            this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.CodigoEppo != '' ||
            this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.IdNombreCientificoDescripcion != '' ||
            this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.NombreComun != '' ||
            this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.Activo != EnumSiNoTodos.TODOS ||
            this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.HabilitadoImportacion != EnumSiNoTodos.TODOS ||
            this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.HabilitadoExportacion != EnumSiNoTodos.TODOS ||
            this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.HabilitadoChina != EnumSiNoTodos.TODOS ||
            this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.EphytoReinoUnido != EnumSiNoTodos.TODOS ||
            this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.AplicaDocumentacion != EnumSiNoTodos.TODOS
        ) {
            this.form.patchValue({
                CodigoEppo: this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.CodigoEppo,
                IdNombreCientificoDescripcion: this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.IdNombreCientificoDescripcion,
                NombreComun: this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.NombreComun,
                Activo: this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.Activo,
                HabilitadoImportacion: this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.HabilitadoImportacion,
                HabilitadoExportacion: this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.HabilitadoExportacion,
                HabilitadoChina: this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.HabilitadoChina,
                EphytoReinoUnido: this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.EphytoReinoUnido,
                AplicaDocumentacion: this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.AplicaDocumentacion,
            });

            hayFiltros = true;
        }

        if (hayFiltros) this.onSearchButton();
    }

    onSearchButton() {
        if (this.turboTable) {
            this.turboTable.first = 0;
        }

        this.Search(0);

        this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.IdGrupo = this.form.value.IdGrupo;
        this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.IdForma = this.form.value.IdForma;
        this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.IdSubForma = this.form.value.IdSubForma;
        this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.CodigoEppo = this.form.value.CodigoEppo;
        this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.IdNombreCientificoDescripcion = this.form.value.IdNombreCientificoDescripcion;
        this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.NombreComun = this.form.value.NombreComun;
        this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.Activo = this.form.value.Activo;

        this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.HabilitadoImportacion = this.form.value.HabilitadoImportacion;
        this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.HabilitadoExportacion = this.form.value.HabilitadoExportacion;
        this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.HabilitadoChina = this.form.value.HabilitadoChina;
        this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.EphytoReinoUnido = this.form.value.EphytoReinoUnido;
        this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.AplicaDocumentacion = this.form.value.AplicaDocumentacion;

        this.searchingButton = true;
        this.isCollapsed = true;
    }

    Search(pageNumber: number, asc = 0, orderBy = '') {
        let params = new HttpParams();

        params = params.append('pageNumber', pageNumber.toString());
        params = params.append('asc', asc.toString());
        params = params.append('orderBy', orderBy);
        params = params.append('idGrupo', this.form.value.IdGrupo);
        params = params.append('idForma', this.form.value.IdForma);
        params = params.append('idSubForma', this.form.value.IdSubForma);
        params = params.append('codigoEppo', this.form.value.CodigoEppo);
        params = params.append('idNombreCientificoDescripcion', this.form.value.IdNombreCientificoDescripcion);
        params = params.append('nombreComun', this.form.value.NombreComun);
        params = params.append('activo', this.form.value.Activo);
        params = params.append('habilitadoImportacion', this.form.value.HabilitadoImportacion);
        params = params.append('habilitadoExportacion', this.form.value.HabilitadoExportacion);
        params = params.append('habilitadoChina', this.form.value.HabilitadoChina);
        params = params.append('ephytoReinoUnido', this.form.value.EphytoReinoUnido);
        params = params.append('aplicaDocumentacion', this.form.value.AplicaDocumentacion);

        this.loading = true;
        this.especiesGruposFormasService.getEspeciesGruposFormasPagedByFilter(params).subscribe(result => {
            this.resultEspeciesGruposFormas = result;
            this.loading = false;
        });
    }

    onSearchLazy(event: any) {
        if (!event.rows || event.sortField == 'Link') {
            return;
        }

        let pageNumber = event.first / event.rows;
        this.Search(pageNumber, event.sortOrder, event.sortField);
    }

    onCleanButton() {
        this.form.setValue({
            IdGrupo: null,
            IdForma: null,
            IdSubForma: null,
            CodigoEppo: '',
            IdNombreCientificoDescripcion: '',
            NombreComun: '',
            Activo: EnumSiNoTodos.TODOS,
            HabilitadoImportacion: EnumSiNoTodos.TODOS,
            HabilitadoExportacion: EnumSiNoTodos.TODOS,
            HabilitadoChina: EnumSiNoTodos.TODOS,
            EphytoReinoUnido: EnumSiNoTodos.TODOS,
            AplicaDocumentacion: EnumSiNoTodos.TODOS,
        });
        this.searchingButton = false;
        this.isCollapsed = false;

        this.listForma = [];
        this.listSubForma = [];

        this.resultEspeciesGruposFormas = new WBotanicaExtendedItemResultsViewModel();
    }

    onSelectGrupo() {
        const idGrupo = this.form.value.IdGrupo;

        //limpiar listas que alimentan los combos dependientes
        this.globalService.getFormasByGrupo(idGrupo).subscribe(res => {
            this.listForma = res;
        });
        this.listSubForma = [];

        this.form.patchValue({
            IdForma: null,
            IdSubForma: null,
        });
    }

    onSelectForma() {
        const idForma = this.form.value.IdForma;

        this.globalService.getSubFormasByForma(idForma).subscribe(res => {
            this.listSubForma = res;
        });

        this.form.patchValue({
            IdSubForma: null,
        });
    }

    onAdd() {
        this.router.navigate(['/mantenimiento/especies/especiesgruposformas/create']);
    }

    onEdit(item: WBotanicaExtendedViewModel) {
        this.router.navigate(['/mantenimiento/especies/especiesgruposformas/edit', item.Id]);
    }

    onDelete(item: WBotanicaExtendedViewModel) {
        this.confirmationService.confirm({
            message: '¿Está seguro?',
            accept: () => {
                //Actual logic to perform a confirmation
                this.especiesGruposFormasService.deleteEspeciesGruposFormas(item.Id).subscribe({
                    next: res => {
                        this.addSuccessMessage('Especie eliminada correctamente');
                        this.onSearchButton();
                    },
                    error: error => {
                        this.catchServerError(error);
                    },
                });
            },
        });
    }

    CreateModel() {
        let model: FilterSearchingWBotanicaExtendedViewModel = new FilterSearchingWBotanicaExtendedViewModel();

        Object.assign(model, this.form.value);

        return model;
    }

    onExportExcel() {
        this.visibilitySpinner = true;

        this.especiesGruposFormasService.export(this.CreateModel()).subscribe(res => {
            this.OpenDownloadedFile(res);

            this.visibilitySpinner = false;
        });
    }
}
